<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">微信聊天</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">聊天接管</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="clue-search">
            <div class="left">
                <!-- 日期 -->
                <!-- <a-range-picker :locale="locale" @change="ondateChange" placeholder="请选择日期范围"/> -->
                <!-- 坐席 -->
                <a-select style="width: 120px;margin-left:12px" allowClear @change="userhandleChange" placeholder="坐席" :showArrow="show">
                    <a-select-option mode="multiple" v-for="(option,x) in useroption" :key="x" :value="option.id">
                        {{option.name}}
                    </a-select-option>
                </a-select>

                <!-- 通话时长 -->
            </div>
             
        </div>

        <div class="data-list">
            <a-spin :spinning="tablespinning">
                <a-table  rowKey="uswxlid" :scroll="{x: 1100}" :pagination="pageshow" :columns="columns" :data-source="data">
    
                    <span slot="date" slot-scope="text">
                        <span v-if="text">{{text | showDate }}</span>
                        <span v-else>--</span>
                    </span>

                     <span slot="head" slot-scope="text">
                        <img style="width:50px;border-radius:50%" v-if="text" :src="text"/>
                    </span>

                    <span slot="action" slot-scope="text,record">
                        <a @click="toopenchat(record.uswxlid)" href="javascript:;">聊天记录</a>
                    </span>

                </a-table>

                <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                    <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                    <a-pagination
                    show-size-changer
                    :default-current="1"
                    :page-size-options="pageSizeOptions"
                    :total="pagination.total"
                    :defaultPageSize="10"
                    @change="handleTableChange"
                    @showSizeChange="onShowSizeChange"
                    >
                        <template slot="buildOptionText" slot-scope="props">
                            <span>{{ props.value }}条/页</span>
                        </template>

                    </a-pagination>
                </div>
            </a-spin>
        </div>


        <!-- 聊天记录 -->
        <a-modal
        title="聊天记录"
        :visible="logvisible"
        @cancel="handleCancel"
        :footer="null"
        width="620px"
        >
         <div class="chatpageall" style="height:450px;width:100%">
            <div class="chatpage" style="height:100%;width:100%;overflow-y:auto;">
                <div class="middle" id="chatRecord" style="height:100%;padding:0 16px 0 0;overflow-y:auto;width:100%">
                    <ul v-if="chatloglist">
                        <div v-for="item,i in chatloglist" :key="i">
                            <li v-if="item.opercode==2003">
                                <div class="avatr"><img src="../../../static/head.svg" alt=""></div>
                                <div >
                                    <p>{{item.addtime | showDate}}</p>
                                    <div v-if="item.MsgType=='image'" class="chattext">
                                         <img v-viewer="{movable: false}" class="pictur" :src="item.PicUrl" alt="">
                                    </div>
                                    <div v-if="item.MsgType=='text'" class="chattext">
                                        {{item.content}}
                                    </div>

                                    <div v-if="item.MsgType=='voice'" class="chattext">
                                        <div class="voice-bg" @click="toplay(item.voiceUrl,i)">
                                            <img
                                                :src="item.isPlaying==1 ? '../../static/voice-play.gif':'../../static/voice.png'"
                                                alt=""
                                            />
                                            <span> "</span>
                                        </div>
                                    </div>
                                </div>
                            </li>

                            <li v-else-if="item.opercode==2002" class="chatanswer">
                                <div class="avatr"><img src="../../../static/head.svg" alt=""></div>
                                <div >
                                    <!-- {{}} -->
                                    <p v-if="item.addtime">{{item.addtime | showDate}}</p>
                                    <!-- <p v-else>{{item.time | showDate}}</p> -->
                                    <div v-if="item.MsgType=='text'" class="chattext">
                                        {{item.content}}
                                    </div>
                                     <div v-if="item.MsgType=='image'" class="chattext">
                                         <img v-viewer="{movable: false}" class="pictur" :src="item.PicUrl" alt="">
                                    </div>
                                </div>
                            </li>
                        </div>
                    
                    </ul>

                    <a-empty :description="des" v-else />

                </div>
            </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
import {formatDate} from '../../utils/formate.js'
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import BenzAMRRecorder from 'benz-amr-recorder'
const columns = [
    {title: 'ID',dataIndex: 'uswxlid',key: 'uswxlid',width:80},
    {title: '客户头像',dataIndex: 'headimgurl',key: 'headimgurl',width:90,scopedSlots: { customRender: 'head' }},
    {title: '客户姓名',dataIndex: 'nickname_kh',key: 'nickname_kh',width:90},
    {title: '坐席姓名',dataIndex: 'name_kf',key: 'name_kf',width:90},
    {title: '开始时间',dataIndex: 'addtime',key: 'addtime',width:120,scopedSlots: { customRender: 'date' }},
    {title: '结束时间',dataIndex: 'lastsend',key: 'lastsend',width:120,scopedSlots: { customRender: 'date' }},
    {title: '操作',key: 'action',width:120,scopedSlots: { customRender: 'action' },},
]
export default {
    filters: {
      //年-月-日
      formatDate (time) {
        time = time * 1000
        let date = new Date(time)
        return formatDate (date, 'yyyy-MM-dd')
      },
      showDate(time){
          time = time * 1000
        let date = new Date(time)
        return formatDate (date, 'yyyy-MM-dd hh:mm:ss')
      }
    },
    data(){
        return{
            useroption:[{id:1,name:'坐席1'}],
            locale,

            columns,
            data:[],
            tablespinning:true,
            pageSizeOptions:['10','20','30','40','100','200'],
            pagination:{},
            size:10,
            totalpage:"",
            pageshow:false,
            currentpagination:"",
            addvisible:false,

            tablex:'',
            logvisible:false,

            timer: null,
            isPlaying: false,
            duration:"",

            chatloglist:""
        }
    },
    // watch: {
    //   windowHeight (val) {
    //     this.tablex=val-300
    //   },
    // },
    mounted(){
        this.fetch()

        // window.fullWidth = document.documentElement.clientWidth;
        // this.windowWidth = window.fullWidth;  
        // this.tablex=this.windowWidth-300
        // window.onresize = () => {
        //     return (() => {
        //         window.fullWidth = document.documentElement.clientWidth;
        //         this.windowWidth = window.fullWidth;  // 高
        //         this.tablex=this.windowWidth-300
        //     })()
        // };
    },
    methods:{
        toopenchat(id){
            
             this.$axios.post('/api/wechat1/userwxisltlistpage',{
                uswxlid: id,
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.logvisible=true
                    this.chatloglist=res.data.data
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },

        handleCancel(){
            this.logvisible=false
        },
        toplay(url,i){
            // let vm = this
            // vm.stopPlayVoice()
            var amr = new BenzAMRRecorder();    //创建
            var that=this
            amr.initWithUrl(url).then(function() {
                if (that.chatloglist[i].isPlaying===0) {
                    var duration=amr.getDuration(); 
                    that.duration=duration
                    amr.play();
                    that.chatloglist[i].isPlaying = 1;
                    that.watchEnd(i);
                }else{
                    amr.stop();
                    clearTimeout(that.timer);
                    that.chatloglist[i].isPlaying = 0;
                }
            });
            
        },

        watchEnd(i) {
            let that = this;
            this.timer = setTimeout(() => {
            that.chatloglist[i].isPlaying = 0;
            }, (that.duration + 1) * 1000);
        },
        // 日期范围
        ondateChange(e){

        },
        // 选择坐席
        userhandleChange(){

        },

         // 分页
        handleTableChange(pageNumber) {
            this.currentpage=pageNumber
            this.fetch();
        },
        onShowSizeChange(current,pageSize){
            this.size=pageSize
            this.page=1
            this.fetch();
        },

        // 数据
        fetch(params = {}){
            this.$axios.post('/api/wechat1/userwxisltlist',{
                pagesize: this.size,
                page:this.currentpage,
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.tablespinning=false
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.total;
                    pagination.pageSize=this.size
                    this.data=res.data.data.data
                    this.pagination = pagination;
                    this.totalpage=Math.ceil(res.data.data.total/this.size)
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },

    }
}
</script>


// WEBPACK FOOTER //
// src/components/chat/chatlog.vue